import type { WidgetType } from '../panels/WidgetPanel'

export const widgetManager = {
  clearWidgets(widgetContainerId: string = 'rentware-widget-container', checkoutContainerId: string = 'rentware-checkout-container') {
    const widgetContainer = document.getElementById(widgetContainerId)
    const checkoutContainer = document.getElementById(checkoutContainerId)

    if (widgetContainer) {
      while (widgetContainer.firstChild) {
        widgetContainer.removeChild(widgetContainer.firstChild)
      }
    }
    if (checkoutContainer) {
      while (checkoutContainer.firstChild) {
        checkoutContainer.removeChild(checkoutContainer.firstChild)
      }
    }
  },

  async updateOrRenderWidgets(
    selectedItem: { reference: string } | null,
    selectedAccount: { widgetAccessToken: string } | null,
    view = 'default',
    widgetType: WidgetType = 'rtr-article-booking',
    widgetContainerId: string = 'rentware-widget-container',
    checkoutContainerId: string = 'rentware-checkout-container'
  ) {
    // Check if checkout already exists
    const checkoutContainer = document.getElementById(checkoutContainerId)
    const existingCheckout = checkoutContainer?.querySelector('rtr-checkout')

    if (existingCheckout && selectedAccount) {
      // Update existing checkout with new account
      try {
        await existingCheckout.updateAccount(selectedAccount.widgetAccessToken)
        console.log('Checkout updated with new account')
      } catch (e) {
        console.error('Failed to update checkout:', e)
      }
    } else if (!existingCheckout && checkoutContainer) {
      // Create checkout if it doesn't exist
      const rtrCheckout = document.createElement('rtr-checkout')
      checkoutContainer.append(rtrCheckout)
    }

    // Always re-render widget when item or widget type changes
    const widgetContainer = document.getElementById(widgetContainerId)
    if (widgetContainer) {
      widgetContainer.innerHTML = ''

      // Handle different widget types
      if (widgetType === 'rtr-search') {
        // Search widget doesn't need article-id
        const element = document.createElement(widgetType)
        element.setAttribute('view', view)
        widgetContainer.append(element)
      } else if (widgetType === 'rtr-order') {
        // Order widget might need order ID - for now just render it
        const element = document.createElement(widgetType)
        widgetContainer.append(element)
      } else if (selectedItem?.reference) {
        // Widgets that require article-id
        const element = document.createElement(widgetType)
        element.setAttribute('article-id', selectedItem.reference)

        // Set view attribute based on widget type
        if (widgetType === 'rtr-article-booking' || widgetType === 'rtr-article-details' || widgetType === 'rtr-page') {
          element.setAttribute('view', view)
        }

        widgetContainer.append(element)
      }
    }
  }
}
